const twi=(className="")=>className.trim().split(" ").map(c=>c.startsWith("!")||!c||c.includes(":")||c.includes("[")?c:`!${c}`).join(" ");export{twi};
